var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header',[_c('div',{staticClass:"left"},[_vm._t("left")],2),_c('div',{staticClass:"mid"},[_vm._t("mid")],2),_c('i',{staticClass:"iconfont icon-menu",on:{"click":_vm.showNavHandle}})]),_c('Nav',{ref:"nav"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }